import React from 'react';
import './LoadingSpinner.css'; // We will create this CSS file next

const LoadingSpinner = ({ message }) => {
  return (
    <div className="loading-spinner-overlay">
      <div className="loading-spinner"></div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner; 